@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.CopyToClipboardWithIcon {
  @extend %font-family-primary;

  display: flex;
  flex-direction: row;
  column-gap: 4px;
  align-items: center;
  font-size: $font-size-normal;
  font-weight: $font-weight-semibold;
  line-height: 18px;

  .CopyText {
    color: $theme-color-text;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 80px;
    white-space: nowrap;
  }

  .CopyIcon {
    top: 4px;
  }

  &.sub-header {
    background: $theme-color-table-header-background;
  }

  &.runner {
    background: transparent;
  }
}
